import { Input } from '../ui/input';
import { COLOR_RE } from '../../lib/work-types';

export const DEFAULT_COLOR = '#60646C';

export function ColorSwatch({ color, className }: { color: string; className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={className ?? 'inline-block h-3 w-3 shrink-0 rounded-full border'}
      style={{ backgroundColor: COLOR_RE.test(color) ? color : DEFAULT_COLOR }}
    />
  );
}

export function ColorField({
  id,
  value,
  onChange,
}: {
  id: string;
  value: string;
  onChange: (color: string) => void;
}) {
  return (
    <div className="flex items-center gap-2">
      <input
        type="color"
        aria-label="Pick colour"
        value={COLOR_RE.test(value) ? value : DEFAULT_COLOR}
        onChange={(event) => onChange(event.target.value.toUpperCase())}
        className="h-9 w-10 shrink-0 cursor-pointer rounded-md border bg-background p-1"
      />
      <Input
        id={id}
        value={value}
        maxLength={7}
        spellCheck={false}
        placeholder={DEFAULT_COLOR}
        className="font-mono"
        onChange={(event) => onChange(event.target.value.toUpperCase())}
      />
    </div>
  );
}
